const getFileNameWithoutExtension = (fileName: string, nameMaxLength?: number): string => {
   const fileNameSplit = fileName.split('.');
   const filename: string = fileNameSplit.reduce((accumulator: string, currentValue: string, currentIndex: number) => {
      if (accumulator === '' || currentIndex < fileNameSplit.length - 1) {
         return accumulator === '' ? `${accumulator}${currentValue}` : `${accumulator}.${currentValue}`;
      } else {
         return accumulator;
      }
   }, '');

   if (nameMaxLength && filename.length > nameMaxLength) {
      return filename.substr(0, nameMaxLength);
   } else {
      return filename;
   }
};

export default {getFileNameWithoutExtension};
